<template>
  <div class="rule">
    <div class="content-header" v-if="isApp!=1">
       <i @click="$router.go(-1)" class="iconfont icon-left" :class="{mirrorRotateLevel:isDirection}"></i>
       <span class="bold">{{$t('300292')}}</span>
    </div>
    <div v-html="rule" class="content-main">
    </div>
    <!-- <div class="content-main"></div> -->
  </div>
</template>

<script>
import { getPurchaseRules } from './api'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      rule: ''
    }
  },
  computed:{
    ...mapGetters(['isDirection','isApp'])
  },
  created(){
    this.getRule()
  },
  methods: {
    getRule() {
      getPurchaseRules().then(res => {
        this.rule = res.data.content
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/variableName";
@import "../../style/mixin";
[dir='ltr'] {
  i{
    float: left;
  }
}
[dir='rtl'] {
  i{
    float: right;
  }
}
.rule {
  width: 100vw;
  // height: 100%;
  min-height: 100vh;
  padding-bottom: torem(40);
  background: #fff;
}
.content-header {
  width: 100%;
  height: torem(44);
  // position: fixed;
  background: #ffffff;
  // top: 0;
  // left: 0;
  line-height: torem(44);
  padding: 0 torem(16);
  box-sizing: border-box;
  i {
    font-size: torem(18);
    // float: left;
  }
  font-size: torem(18);
  color: rgba(0, 9, 34, 1);
  text-align: center;
}
.content-main {
  padding: torem(18) torem(16) 0;
  box-sizing: border-box;
  font-size: torem(14);
  line-height: torem(21);
  color: rgba(64, 71, 90, 1);
}
</style>



// WEBPACK FOOTER //
// src/view/purchase/rule.vue